import { BrowserRouter, MemoryRouter } from 'react-router-dom';
import type { ReactNode } from 'react';
import { AuthProvider } from './auth/AuthProvider.js';
import { Router } from './router.js';
import { VendorBrandingProvider } from './theme/branding.js';
import { WebI18nProvider } from '../../shared/i18n/web.js';

export interface AppProps {
  /** Test-only: use a MemoryRouter with optional initial entries. */
  readonly initialEntries?: readonly string[];
}

/**
 * Top-level TradeLogic Vendor Portal app. Composes i18n + Router + AuthProvider.
 * Test-only: pass `initialEntries` to use a MemoryRouter for in-memory routing.
 */
export function App({ initialEntries }: AppProps): ReactNode {
  const inner = (
    <WebI18nProvider>
      <AuthProvider>
        <VendorBrandingProvider>
          <Router />
        </VendorBrandingProvider>
      </AuthProvider>
    </WebI18nProvider>
  );
  if (initialEntries) {
    return <MemoryRouter initialEntries={[...initialEntries]}>{inner}</MemoryRouter>;
  }
  return <BrowserRouter>{inner}</BrowserRouter>;
}
